module.exports = "/assets/site/images/nagy_arpad_portfolio.jpg?74c3d6e786a4544bb4c671ccf8278f70";